import Rx from "rxjs/Rx";
import { searchTypeFilterEnabled$ } from "./search-page-type-filter.component";
import { allSearchTypeFiltersDisabled$ } from "./type-filters-panel.component";

export const calculatorTabSelectedSource = new Rx.Subject();
export const calculatorTabSelected$ = calculatorTabSelectedSource.asObservable();

export const rowsTabSelectedSource = new Rx.Subject();
export const rowsTabSelected$ = rowsTabSelectedSource.asObservable();

const states = {
    nothingSelected: 0,
    calculatorTabSelected: 1,
    areasTabSelected: 2,
};

export class TabSwitcherComponent {
    constructor(node) {
        this.node = node;
        this.initialize();
        this.subscribeOnTypeFiltersChanges();
        this.initCalculatorTabOnClick();
        this.initRowsTabOnClick();
        this.currentTypeFilter = null;
        this.currentState = states.nothingSelected;
    }

    subscribeOnTypeFiltersChanges() {
        searchTypeFilterEnabled$.subscribe((typeFilter) => {
            this.removeSwitchVisualSelection();
            this.currentTypeFilter = typeFilter;
            this.showRowsTab();
            if (!typeFilter.hasCalculator) {
                this.disableCalculatorVisually();
            }
        });

        allSearchTypeFiltersDisabled$.subscribe(() => {
            this.removeSwitchVisualSelection();
            this.currentTypeFilter = null;
            this.showRowsTab();
            this.disableCalculatorVisually();
        });
    }

    initialize() {
        const options = this.node.find(".custom-search-panel-square-selection-option");
        this.rowsTab = options.eq(0);
        this.calculatorTab = options.eq(1);
        this.tabIncline = this.node.find(".tab-incline-group").eq(0);
    }

    showCalculator() {
        this.calculatorTab.addClass("active");
        this.rowsTab.removeClass("active");
        this.currentState = states.calculatorTabSelected;
        if (this.tabIncline) {
            this.tabIncline.removeClass("first-selected");
            this.tabIncline.addClass("second-selected");
        }
        calculatorTabSelectedSource.next();
    }

    showRowsTab() {
        this.rowsTab.addClass("active");
        this.calculatorTab.removeClass("active");
        this.currentState = states.areasTabSelected;
        if (this.tabIncline) {
            this.tabIncline.removeClass("second-selected");
            this.tabIncline.addClass("first-selected");
        }
        rowsTabSelectedSource.next();
    }

    disableCalculatorVisually() {
        this.calculatorTab.addClass("disabled");
        this.tabIncline.addClass("calculator-disabled");
    }

    initCalculatorTabOnClick() {
        this.calculatorTab.on("click",
            () => {
                if (!this.currentTypeFilter
                    || !this.currentTypeFilter.hasCalculator
                    || this.currentState === states.calculatorTabSelected) {
                    return;
                }

                this.showCalculator();
            });
    }

    initRowsTabOnClick() {
        this.rowsTab.on("click",
            () => {
                if (!this.currentTypeFilter
                    || this.currentState === states.areasTabSelected) {
                    return;
                }
                this.showRowsTab();
            });
    }

    removeSwitchVisualSelection() {
        this.rowsTab.removeClass("active");
        this.rowsTab.removeClass("disabled");
        this.calculatorTab.removeClass("active");
        this.calculatorTab.removeClass("disabled");
        this.tabIncline.removeClass("calculator-disabled");
    }
}
